import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { TransactionGroup } from './enums/TransactionGroup';
import { TransactionFlow } from './enums/TransactionFlow';

export class WalletStatement {
  @Expose({ name: 'wallet_balance' })
  walletBalance: string;

  @Expose({ name: 'total_paid' })
  totalPaid: string;

  @Expose({ name: 'total_pending' })
  totalPending: string;

  @Expose({ name: 'recent_transactions' })
  @Type(() => WalletTransaction)
  recentTransactions?: WalletTransaction[];

  @Expose({ name: 'transaction_labels' })
  transactionLabels?: Record<string, string>;

  constructor(
    walletBalance: string,
    totalPaid: string,
    totalPending: string,
    recentTransactions?: WalletTransaction[],
    transactionLabels?: Record<string, string>
  ) {
    this.walletBalance = walletBalance;
    this.totalPaid = totalPaid;
    this.totalPending = totalPending;
    this.recentTransactions = recentTransactions;
    this.transactionLabels = transactionLabels;
  }

  static fromJson(json: Record<string, any>): WalletStatement {
    return plainToInstance(WalletStatement, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class WalletTransaction {
  id: number;

  @Expose({ name: 'transaction_group' })
  group: TransactionGroup;

  @Expose({ name: 'transaction_type' })
  type: string;

  @Expose({ name: 'transaction_key' })
  key: string;

  amount: string;

  @Expose({ name: 'cash_flow' })
  flow: TransactionFlow;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  level?: number;

  @Expose({ name: 'from_user' })
  fromUser?: string;

  @Expose({ name: 'rank_name' })
  rankName?: string;

  constructor(
    id: number,
    group: TransactionGroup,
    type: string,
    key: string,
    amount: string,
    flow: TransactionFlow,
    dateCreated: Date,
    level?: number,
    fromUser?: string,
    rankName?: string
  ) {
    this.id = id;
    this.group = group;
    this.type = type;
    this.key = key;
    this.amount = amount;
    this.flow = flow;
    this.dateCreated = dateCreated;
    this.level = level;
    this.fromUser = fromUser;
    this.rankName = rankName;
  }

  static fromJson(json: Record<string, any>): WalletTransaction {
    return plainToInstance(WalletTransaction, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
